import { useIncreaseQtyInbound } from 'hooks/useProduct';
import { IncreaseProductQtyInboundInput } from 'services/interface';
import styled from '@emotion/styled';
import { Button, Form, Input, Modal, message } from 'antd'
import TextArea from 'antd/es/input/TextArea';
import React, { Dispatch, FC, SetStateAction } from 'react'
import { PlusCircleOutlined } from '@ant-design/icons';

interface ProductAddDialogsProps {
    id: string | undefined;
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
}
const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
    },
};

const DEFAULT_INBOUND_TYPE = 'myself';

const ProductAddDialogs: FC<ProductAddDialogsProps> = ({ id, open, setOpen }) => {
    const { mutate: increaseInbound } = useIncreaseQtyInbound();
    const [form] = Form.useForm();

    const onClose = () => {
        setOpen(false);
    };
    const onFinish = (values: any) => {
        const dataInbound: IncreaseProductQtyInboundInput = {
            product_id: id ?? '',
            quantity: values.quantity,
            remark: values.remark,
            inbound_type: DEFAULT_INBOUND_TYPE,
        }
        increaseInbound(dataInbound, {
            onSuccess: (data) => {
              if (data.status === "success") {
                message.success("เพิ่มจำนวนสินค้าเข้าสต๊อกสำเร็จ");
                onClose();
                form.resetFields();
                // refetch();
              }else {
                message.error(`เพิ่มจำนวนสินค้าเข้าสต๊อกไม่สำเร็จ ${data.error_message?.[0]}`);
              }
            },
            onError: () => {
              message.error("เพิ่มจำนวนสินค้าเข้าสต๊อกไม่สำเร็จ");
            },
          });
    }
    return (
        <>
            {/* <ButtonWrapper>
                <Button
                    type="default"
                    // style={{ width: 200 }}
                    onClick={() => showDrawer()}
                    size="small"
                >
                    <PlusCircleOutlined /> เพิ่มสต๊อกสินค้า
                </Button>
            </ButtonWrapper> */}

            <Modal
                title="เพิ่มรายการ"
                open={open}
                // width={1000}
                maskClosable={false}
                onCancel={onClose}
                style={{ top: 20 }}
                onOk={() => {
                    form.submit();
                }}
                cancelText="ยกเลิก" okText="เพิ่ม"
            >
                <Form form={form} {...formItemLayout} onFinish={onFinish}>
                    <FormWrapper>
                        <FormItems
                            label="จำนวน"
                            labelAlign="left"
                            name="quantity"
                            rules={[{ required: true, message: "เลือกจำนวน" }]}
                        >
                            <Input
                                placeholder="จำนวน"
                                type="number"
                                autoComplete="off"
                            />
                        </FormItems>
                        <FormItems
                            label="หมายเหตุ"
                            labelAlign="left"
                            name="remark"
                        >
                            <TextArea placeholder="หมายเหตุ" rows={5} />
                        </FormItems>
                    </FormWrapper>
                </Form>
            </Modal>
        </>
    )
}

export default ProductAddDialogs

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffffff;
`;

const FormItems = styled(Form.Item)`
    margin-bottom: 10px;
    width:100%
`
const ButtonWrapper = styled.div`
    margin-left: auto; 
    display: flex;
    justify-content: center;
    align-items: flex-end;
    flex-direction: column;
    padding:5px;
`;
